module.exports = __webpack_public_path__ + "img/vcc.065fd5aa.jpg";